import PropTypes from "prop-types";
import labels from "../../../../config/labels";
import { Container, CustomContainer } from "../../../atoms/DependencyHelper";
import LabelText from "../../../atoms/label/LabelText";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import IconBundles from "../../../../public/assets/images/bundles.svg";
import RecentlyViewed from "../recentlyViewed/RecentlyViewed";

import styles from "./OrderHistoryEmpty.module.scss";

const OrderHistoryEmpty = ({ goToProducts, productItems }) => {

  return (
    <Container className={`mainContainer text-center mt-m ${styles["order-history-empty"]} ${!productItems ? "mb-7" : ""}`}>
      <CustomContainer className={`${styles["order-history-empty--image-container"]}`}>
        <IconBundles
          width="5rem"
          width="5rem"
          className={`d-block mx-auto ${styles["bundles-image"]}`}
        />
      </CustomContainer>
      <LabelText className={`content mt-s d-block ${styles["order-history-empty--message"]}`}>
        You haven’t made any online purchases yet
      </LabelText>
      <CustomContainer className={styles["button-container"]}>
        <CTAButton
          className={`${styles["round-btn"]} mt-l`}
          variant="outline black"
          handleClick={goToProducts}
          id="start-shopping"
        >
          Start shopping
        </CTAButton>
      </CustomContainer>
      {productItems && (<RecentlyViewed recentViewed={productItems} />)}
    </Container>
  );
}

export default OrderHistoryEmpty;
